// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__IKvSi","background":"Banner_background__LCJNu","text_in_banner":"Banner_text_in_banner__XclLH"};